export default "__VITE_ASSET__XrU5xtmx__"